import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {Alert, Button, Card, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import axios from 'axios';
import { connect } from 'react-redux';
import {Spinner} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import cities from '../../utils/json/tinh-thanh.json';
import districts from '../../utils/json/quan-huyen.json';
import wards from '../../utils/json/phuong-xa.json';

class RegisterComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            email: '',
            password: '',
            remember: false,
            error: false,
            messageError: '',
            btnDisable: false,
            role: false,
            name: '',
            gender: 'nam',
            phone: '',
            address: '',
            company: '',
            district: '',
            city: '',
            ward: '',
            confirmPassword: '',
            date: new Date(),
            strengPass: 0,
            isValidName: false,
            isValidEmail: false,
            isValidPhone: false,
            isValidAndrees: false,
            isValidPassword: false,
            isValidConfirmPassword: false,
            isValidCity: false,
            isValidDistrict: false,
            isValidWard: false,
            showCity: false,
            showDistrict: false,
            showWard: false,
            disableInpDistrict: true,
            disableInpWard: true,
            cityId: 0,
            districtId: 0,
        }
    }

    submitLogin = () => {
        // console.log( this.state.email + ' - ' + this.state.password + ' - ' + this.state.remember  );
        this.setState({
            btnDisable: true
        })
        let validate = this.validate();
        if ( validate ) {
            let item = {
                'name': this.state.name,
                'email': this.state.email,
                'gender': this.state.gender,
                'phone': this.state.phone,
                'address': this.state.address,
                'password': this.state.password,
                'confirmPassword': this.state.confirmPassword,
                'date': this.state.date,
                'city': this.state.city,
                'district': this.state.district,
                'ward': this.state.ward,
            };
            this.setState({
                isLoading: true
            });

            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };

            axios.post( process.env.REACT_APP_API_URL + '/api/register', item,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    this.setState({
                        isLoading: false
                    });
                    if ( ref.data.error === 0 ) {
                        // console.log(ref.data);
                        this.redirect( ref.data );
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            btnDisable: false
                        })
                    }
                    // console.log(this.state.perPage);
                })
                .catch( () => {
                    // console.log(error);
                    this.setState({
                        error: true,
                        messageError: 'Tạo tài khoản thất bại',
                        isLoading: false,
                        btnDisable: false
                    })
                })
        }
    }

    redirect = async (item) => {
        await this.props.updateSuccessNotiUser(item);
        await this.props.redirect();
    }

    validate = () => {
        if ( this.state.name.length === 0 ) {
            this.setState({
                error: true,
                messageError: 'Họ và tên không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if ( this.state.name.length < 5 || this.state.name.length > 100 ) {
            this.setState({
                error: true,
                messageError: 'Số ký tự Họ và tên của tài khoản không được nhỏ hơn 5 hoặc lớn hơn 100 ký tự',
                btnDisable: false
            })
            return false;
        }
        else if ( this.state.email.length === 0 ) {
            this.setState({
                error: true,
                messageError: 'Email không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if ( !this.validateEmail(this.state.email) ) {
            this.setState({
                error: true,
                messageError: 'Email không đúng định dạng',
                btnDisable: false
            })
            return false;
        }
        else if ( this.state.gender.length === 0 ) {
            this.setState({
                error: true,
                messageError: 'Giới tính không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if ( this.state.phone.length === 0 ) {
            this.setState({
                error: true,
                messageError: 'Số điện thoại không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if ( !this.validatePhone(this.state.phone) ) {
            this.setState({
                error: true,
                messageError: 'Số điện thoại không đúng định dạng',
                btnDisable: false
            })
            return false;
        }
        else if ( this.state.address.length === 0 ) {
            this.setState({
                error: true,
                messageError: 'Địa chỉ không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if ( this.state.date.length === 0 ) {
            this.setState({
                error: true,
                messageError: 'Ngày sinh không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if ( this.state.password.length === 0 ) {
            this.setState({
                error: true,
                messageError: 'Mật khẩu không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if ( this.state.confirmPassword.length === 0 ) {
            this.setState({
                error: true,
                messageError: 'Nhập lại mật khẩu không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if ( this.state.password !== this.state.confirmPassword ) {
            this.setState({
                error: true,
                messageError: 'Nhập lại mật khẩu không đúng',
                btnDisable: false
            })
            return false;
        }
        else if ( this.passwordChanged( this.state.password ) < 75 ) {
            this.setState({
                error: true,
                messageError: 'Mật khẩu yếu. Mật khẩu phải có ký tự chữ số, chữ hoa, chữ thường và ký tự đặc biệt',
                btnDisable: false
            })
            return false;
        }
        else if (this.props.config.is_role ) {
            if ( !this.state.role ) {
                this.setState({
                    error: true,
                    messageError: 'Chưa đồng ý với các điều khoản và chính sách',
                    btnDisable: false
                })
                return false;
            }
        }
        else if (this.state.city.length === 0) {
            this.setState({
                error: true,
                messageError: 'Tỉnh/Thành Phố không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if ( !this.validateCity(this.state.city) ) {
            this.setState({
                error: true,
                messageError: 'Tỉnh/Thành Phố không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if (this.state.district.length === 0) {
            this.setState({
                error: true,
                messageError: 'Quận/Huyện không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if ( !this.validateDistrict(this.state.district) ) {
            this.setState({
                error: true,
                messageError: 'Quận/Huyện không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if (this.state.ward.length === 0) {
            this.setState({
                error: true,
                messageError: 'Phường/Xã không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if ( !this.validateWard(this.state.ward) ) {
            this.setState({
                error: true,
                messageError: 'Phường/Xã không được để trống',
                btnDisable: false
            })
            return false;
        }
        return true;
    }

    validateCity = (stateCity) => {
        var check = false;
        // eslint-disable-next-line array-callback-return
        cities.data.map( (city) => {
            if ( city.fullName === stateCity )
            {
                check = true;
            }
        })
        return check;
    }

    validateDistrict = (stateDistrict) => {
        var check = false;
        // eslint-disable-next-line array-callback-return
        districts.data.map( (district) => {
            if ( district.fullName === stateDistrict )
            {
                check = true;
            }
        })
        return check;
    }

    validateWard = (stateWard) => {
        var check = false;
        // eslint-disable-next-line array-callback-return
        wards.data.map( (ward) => {
            if ( ward.fullName === stateWard )
            {
                check = true;
            }
        })
        return check;
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
        switch (name) {
            case 'name':
                this.setState({
                    isValidName: (value.length > 2)
                })
                break;
            case 'email':
                var checkEmail = this.validateEmail(value);
                this.setState({
                    isValidEmail: checkEmail
                })
                break;
            case 'phone':
                this.setState({
                    isValidPhone: this.validatePhone(value)
                })
                break;
            case 'address':
                this.setState({
                    isValidAndrees: (value.length > 2)
                })
                break;
            default:
                break;
        }
    }

    validateEmail = (email) => {
        let regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    validatePhone = (phone) => {
        if ( phone.length && !isNaN(parseFloat(phone)) ) {
            let pattern  = /((09|03|07|08|05)+([0-9]{8})\b)/g;
            return pattern.test(phone);
        }
        return false;
    }

    changePassword = (event) => {
        let name = event.target.name;
        let password = event.target.value;
        let strengPass = this.passwordChanged(password);
        this.setState({
            [name]: password,
            strengPass: strengPass,
            isValidPassword: (strengPass >= 75)
        });
    }

    changeConfirmPassword = (event) => {
        let name = event.target.name;
        let passwordConfirm = event.target.value;
        this.setState({
            [name]: passwordConfirm,
            isValidConfirmPassword: (passwordConfirm === this.state.password)
        });
    }

    //kiểm tra mật khẩu
    passwordChanged = (pass) => {
        var  symbolSize = 0, natLog, score;
        var format = /[`!@#$%^&*()_+\-=\\[\]{};':",.<>?~]/;

        if ( pass.match(/[0-9]/) ) {
            symbolSize +=20;
        }
        if ( pass.match(/[a-z]/) ) {
            symbolSize +=28;
        }
        if ( pass.match(/[A-Z]/) ) {
            symbolSize +=28;
        }
        if ( format.test(pass) ) {
            symbolSize +=35;
        }
        if ( pass.match(/[^a-zA-Z0-9]/) ) {
            symbolSize +=35;
        }

        natLog = Math.log( Math.pow(symbolSize, pass.length) );
        score = natLog / Math.LN2;
        if (score > 100) {
            return 100;
        }
        return parseInt(score);
    }

    setDate = (date) => {
        this.setState({
            date: date
        })
    }

    handleClickInpCity = () => {
        this.setState({
            showCity: true,
            showDistrict: false,
            showWard: false,
        })
    }

    handleFocusInpCity = () => {
        this.setState({
            showCity: true,
            showDistrict: false,
            showWard: false,
        })
    }

    mouseLeaveInpCity = () => {
        this.setState({
            showCity: false
        })
    }

    handleClickSelectCity = (cityId, cityFullName) => {
        this.setState({
            cityId: cityId,
            city: cityFullName,
            disableInpDistrict: false,
            isValidCity: true,
            showCity: false,
            showDistrict: false,
            showWard: false,
            disableInpWard: true,
            district: '',
            ward: ''
        })
    }

    loadCity = () => {
        let stateCity = this.state.city.toLowerCase()
            .normalize('NFD')  // Chuẩn hóa ký tự Unicode
            .replace(/[\u0300-\u036f]/g, '');

        var data = cities.data.filter(function(city) {
            const cityName = city.fullName.toLowerCase()
                .normalize('NFD')  // Chuẩn hóa ký tự Unicode
                .replace(/[\u0300-\u036f]/g, '');
            return cityName.toLowerCase().includes(stateCity);
        });

        return (
            // eslint-disable-next-line array-callback-return
            data.map((city) => {
                return (
                    <li
                        className="fillter-choose-city"
                        key={city.id}
                        onClick={() => this.handleClickSelectCity(city.id, city.fullName)}
                    >
                        {city.fullName}
                    </li>
                )
            })
        )

    }

    handleClickInpDistrict = () => {
        this.setState({
            showCity: false,
            showDistrict: true,
            showWard: false,
        })
    }

    handleFocusInpDistrict = () => {
        this.setState({
            showCity: false,
            showDistrict: true,
            showWard: false,
        })
    }

    loadDistrict = () => {
        let stateDistrict = this.state.district.toLowerCase()
            .normalize('NFD')  // Chuẩn hóa ký tự Unicode
            .replace(/[\u0300-\u036f]/g, '');

        let cityId = this.state.cityId;
        // eslint-disable-next-line array-callback-return
        var dataDistrict = districts.data.filter(function(district) {
            if (district.provinceId === cityId) {
                return district;
            }
        })

        if ( dataDistrict.length )
        {
            var data = dataDistrict.filter(function(district) {
                const districtName = district.fullName.toLowerCase()
                    .normalize('NFD')  // Chuẩn hóa ký tự Unicode
                    .replace(/[\u0300-\u036f]/g, '');
                return districtName.toLowerCase().includes(stateDistrict);
            });

            return (
                // eslint-disable-next-line array-callback-return
                data.map((district) => {
                    return (
                        <li
                            className="fillter-choose-district"
                            key={district.id}
                            onClick={() => this.handleClickSelectDistrict(district.districtId, district.fullName)}
                        >
                            {district.fullName}
                        </li>
                    )
                })
            )
        }
        else
        {
            return (
                <li
                    className="fillter-choose-district"
                >
                    Quận/Huyện của Tỉnh/Thành Phố không tồn tại
                </li>
            );
        }
    }

    handleClickSelectDistrict = (districtId, districtFullName) => {
        this.setState({
            districtId: districtId,
            district: districtFullName,
            isValidDistrict: true,
            showCity: false,
            showDistrict: false,
            showWard: false,
            disableInpWard: false,
            ward: ''
        })
    }

    handleClickInpWard = () => {
        this.setState({
            showCity: false,
            showDistrict: false,
            showWard: true,
        })
    }

    handleFocusInpWard = () => {
        this.setState({
            showCity: false,
            showDistrict: false,
            showWard: true,
        })
    }

    loadWard = () => {
        let stateWard = this.state.ward.toLowerCase()
            .normalize('NFD')  // Chuẩn hóa ký tự Unicode
            .replace(/[\u0300-\u036f]/g, '');
        let districtId = this.state.districtId;
        // console.log(districtId)
        // eslint-disable-next-line array-callback-return
        var dataWard = wards.data.filter(function(ward) {
            if (ward.districtId === districtId) {
                return ward;
            }
        })

        if ( dataWard.length )
        {
            var data = dataWard.filter(function(ward) {
                const wardName = ward.fullName.toLowerCase()
                    .normalize('NFD')  // Chuẩn hóa ký tự Unicode
                    .replace(/[\u0300-\u036f]/g, '');
                return wardName.toLowerCase().includes(stateWard);
            });

            return (
                // eslint-disable-next-line array-callback-return
                data.map((ward) => {
                    return (
                        <li
                            className="fillter-choose-ward"
                            onClick={() => this.handleClickSelectWard(ward.fullName)}
                        >
                            {ward.fullName}
                        </li>
                    )
                })
            )
        }
        else
        {
            return (
                <li
                    className="fillter-choose-ward"
                >
                    Phường/Xã của Quận/Huyện không tồn tại
                </li>
            );
        }
    }

    handleClickSelectWard = (wardFullName) => {
        this.setState({
            ward: wardFullName,
            isValidWard: true,
            showCity: false,
            showDistrict: false,
            showWard: false,
        })
    }

    render() {
        return (
            <>
                {
                    this.state.isLoading ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <Row
                            style={{
                                height: '100vh',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Col sm={10} md={9} lg={6} xl={5} className="m-3">
                                <Card body>
                                    <Form onSubmit={() => this.submitLogin()}>
                                        <div className="text-center pb-3">
                                            <img
                                                src={ this.props.config.website_logo }
                                                className="rounded"
                                                style={{ width: 90, height: "auto", cursor: 'pointer' }}
                                                alt="logo"
                                            />
                                            <h4 className="text-primary mt-2">{ this.props.config.website_company ? this.props.config.website_company : '' }</h4>
                                        </div>
                                        {
                                            this.state.error ? (

                                                <Alert color="danger">
                                                    <div className='text-center'>
                                                        { this.state.messageError }
                                                    </div>
                                                </Alert>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        <FormGroup row className="mb-2">
                                            <Col sm={6} className="mb-2">
                                                <Label for={'name'}>{'Họ và tên'}</Label>
                                                <Input type="text" placeholder="Name" name="name" className={`form-control ${ this.state.isValidName ? 'is-valid' : 'is-invalid' }`} onChange={this.changeInput} value={this.state.name} />
                                            </Col>
                                            <Col sm={6} className="mb-2">
                                                <Label for={'Email'}>{'Email'}</Label>
                                                <Input type="email" placeholder="Email" name="email"  className={`form-control ${ this.state.isValidEmail ? 'is-valid' : 'is-invalid' }`} onChange={this.changeInput} value={this.state.email} />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row className="mb-2">
                                            <Col sm={6} className="mb-2">
                                                <Label for={'gender'}>{'Giới tính'}</Label>
                                                <select name="gender" id="gender" onChange={this.changeInput} value={this.state.gender} className="form-control">
                                                    <option value="nam">Nam</option>
                                                    <option value="nữ">Nữ</option>
                                                </select>
                                            </Col> 
                                            <Col sm={6} className="mb-2">
                                                <Label for={'phone'}>{'Số điện thoại'}</Label>
                                                <Input type="text" placeholder="Số điện thoại" className={`form-control ${ this.state.isValidPhone ? 'is-valid' : 'is-invalid' }`} name="phone" onChange={this.changeInput} value={this.state.phone} />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row className="mb-2">
                                            <Col sm={6} className="mb-2">
                                                <Label for={'date'}>{'Ngày sinh'}</Label>
                                                <DatePicker
                                                    selected={this.state.date}
                                                    onChange={(date) => this.setDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    className="form-control"
                                                    id="date"
                                                />
                                            </Col>
                                            <Col sm={6} className="mb-2">
                                                <Label for={'company'}>{'Công ty'}</Label>
                                                <Input type="text" placeholder="Công ty" className={`form-control`} name="company" onChange={this.changeInput} value={this.state.company} />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row className="mb-2">
                                            <Col sm={6} className="mb-2">
                                                <Label for={'address'}>{'Số nhà và tên đường'}</Label>
                                                <Input type="text" placeholder="Số nhà và tên đường" className={`form-control ${ this.state.isValidAndrees ? 'is-valid' : 'is-invalid' }`} name="address" onChange={this.changeInput} value={this.state.address} />
                                            </Col>
                                            <Col sm={6} className="mb-2" onMouseLeave={this.mouseLeaveInpCity}>
                                                <Label for={'city'}>{'Tỉnh/Thành phố'}</Label>
                                                <Input
                                                    type="text" placeholder="Tỉnh/Thành phố"
                                                    className={`form-control ${ this.state.isValidCity ? 'is-valid' : 'is-invalid' }`}
                                                    autoComplete="off"
                                                    name="city" value={this.state.city}
                                                    onClick={this.handleClickInpCity}
                                                    onFocus={this.handleFocusInpCity}
                                                    onChange={this.changeInput}
                                                />
                                                {
                                                    this.state.showCity ? (
                                                        <div className="fillter-list-search-city">
                                                            <ul>
                                                                { this.loadCity() }
                                                            </ul>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row className="mb-2">
                                            <Col sm={6} className="mb-2">
                                                <Label for={'district'}>{'Quận/Huyện'}</Label>
                                                <Input
                                                    type="text" placeholder="Quận/Huyện"
                                                    className={`form-control ${ this.state.isValidDistrict ? 'is-valid' : 'is-invalid' }`}
                                                    name="district" onChange={this.changeInput} value={this.state.district}
                                                    disabled={this.state.disableInpDistrict}
                                                    autoComplete="off"
                                                    onClick={this.handleClickInpDistrict}
                                                    onFocus={this.handleFocusInpDistrict}
                                                />
                                                {
                                                    this.state.showDistrict ? (
                                                        <div className="fillter-list-search-district">
                                                            <ul>
                                                                { this.loadDistrict() }
                                                            </ul>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                            </Col>
                                            <Col sm={6} className="mb-2">
                                                <Label for={'ward'}>{'Phường/Xã'}</Label>
                                                <Input
                                                    type="text" placeholder="Phường/Xã"
                                                    className={`form-control ${ this.state.isValidWard ? 'is-valid' : 'is-invalid' }`}
                                                    name="ward" onChange={this.changeInput} value={this.state.ward}
                                                    disabled={this.state.disableInpWard}
                                                    autoComplete="off"
                                                    onClick={this.handleClickInpWard}
                                                    onFocus={this.handleFocusInpWard}
                                                />
                                                {
                                                    this.state.showWard ? (
                                                        <div className="fillter-list-search-ward">
                                                            <ul>
                                                                { this.loadWard() }
                                                            </ul>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row className="mb-2">
                                            <Col sm={6} className="mb-2">
                                                <Label for={'Password'}>{'Password'}</Label>
                                                <Input type="password" className={`form-control ${ this.state.isValidPassword ? 'is-valid' : 'is-invalid' }`} placeholder="Password" name="password" onChange={this.changePassword} value={this.state.password} />
                                                <div className="progress mt-1" id="passwordStrengthBar">
                                                    {
                                                        this.state.strengPass > 75 ? (
                                                            <div className="progress-bar progress-bar-success" role="progressbar"
                                                                 aria-valuenow={ this.state.strengPass } aria-valuemin="0" aria-valuemax="100"
                                                                 style={{ width: `${this.state.strengPass}%`}}
                                                            >
                                                                <span className="progress-text color-white text-center">Độ mạnh của mật khẩu: {this.state.strengPass}%</span>
                                                            </div>
                                                        ) : (
                                                            <div
                                                                className="progress-bar progress-bar-danger" role="progressbar"
                                                                aria-valuenow={ this.state.strengPass } aria-valuemin="0" aria-valuemax="100"
                                                                style={{ width: `${this.state.strengPass}%`}}
                                                            >
                                                                <span className="progress-text color-black text-center">Độ mạnh của mật khẩu: {this.state.strengPass}%</span>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </Col>
                                            <Col sm={6} className="mb-2">
                                                <Label for={'confirmPassword'}>{'Nhập lại mật khẩu'}</Label>
                                                <Input type="password" className={`form-control ${ this.state.isValidConfirmPassword ? 'is-valid' : 'is-invalid' }`} placeholder="Nhập lại mật khẩu" name="confirmPassword" onChange={this.changeConfirmPassword} value={this.state.confirmPassword} />
                                            </Col>
                                        </FormGroup>
                                        {
                                            this.props.config.is_role ? (
                                                <FormGroup check>
                                                    <span>
                                                        <Label check>
                                                            <Input type="checkbox" name="role" onChange={this.changeInput} value={this.state.role} />Đồng ý với các
                                                        </Label>
                                                    </span>
                                                    <a href={ this.props.config.website_link_role } target="_blank"
                                                       rel="noreferrer" className="link-role-auth"> điều khoản và chính sách
                                                    </a>
                                                </FormGroup>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        <hr />
                                        <Button
                                            size="lg"
                                            className="bg-gradient-theme-left border-0"
                                            block
                                            onClick={() => this.submitLogin()}
                                            disabled={ this.state.btnDisable }
                                        >
                                            Tạo tài khoản
                                        </Button>
                                    </Form>
                                    <div className="text-center pt-1">
                                        <h6>hoặc</h6>
                                        <h6>
                                            <Link to="/dang-nhap.html">Đăng nhập</Link>
                                        </h6>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    )
                }
            </>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        emailSave: state.login.email,
        passwordSave: state.login.password,
        isSinged: state.login.isSinged,
        config: state.configSystem.config,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        remember: (item) => {
            dispatch(({ type : 'remember', item }))
        },
        login: (item) => {
            dispatch(({ type : 'login', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(RegisterComponent);